export const openFile = (link: Blob | string) => {
  const isBlob = (typeof Blob !== "undefined" && link instanceof Blob)
  let urlFile: string;

  if (isBlob) urlFile = URL.createObjectURL(link)
  else urlFile = link as string;
  
  const newTab = window.open(urlFile, "_blank");

  if (!newTab) alert("Разрешите всплывающие окна для этого сайта, чтобы открыть файл");

  if (isBlob) {
    setTimeout(() => {
      URL.revokeObjectURL(urlFile);
    }, 1500);
  }
}
